import { render, staticRenderFns } from "./WPPageManagerNew.vue?vue&type=template&id=f1ed57c6&"
import script from "./WPPageManagerNew.vue?vue&type=script&lang=ts&"
export * from "./WPPageManagerNew.vue?vue&type=script&lang=ts&"
import style0 from "./WPPageManagerNew.vue?vue&type=style&index=0&id=f1ed57c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports